export default "__VITE_ASSET__DElqyxo1__"